// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1r04ze3t{inset:var(--ds-space-0,0)}\n._fiawglyw:empty{display:none}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
